import React from 'react';
import {
    Tag,
    Row,
    Space,
    Button,
    Input,
    DatePicker,
    Select,
    Table,
    Pagination,
    Checkbox,
    Modal,
    Upload,
    Transfer,
    Form,
    Col,
    Rate,
    Divider,
    Radio,
    message,
    Popconfirm,
    Alert
} from 'antd';
import HtView from '../hetong/view'
import {Redirect, Link, withRouter} from 'react-router-dom';
import store from "../store/store.js";
import {DeleteOutlined, UploadOutlined, EditOutlined, PlusOutlined, PlusCircleOutlined} from '@ant-design/icons'
import moment from 'moment';

const {Option, OptGroup} = Select;
const {TextArea} = Input;
const {RangePicker} = DatePicker;

class Edit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            condition: {
                id: props.id,
            },
            visible: false,
            loading: false,
            loading2: false,
        };
        store.subscribe(() => {
            // console.log('state状态改变了，新状态如下')
            // console.log(store.getState().data.isLogin)
        })
    }

    componentDidMount() {


    }

    sub() {
        let that = this
        that.setState({
            loading: true
        })
        let arr = that.state.condition
        arr.type = that.props.type
        fetch('/Pay/doview', {
            method: "POST",
            body: JSON.stringify(arr)
        })
            .then(res => res.json())
            .then(data => {
                if (data.status == 1) {
                    message.success(data.msg);
                    this.props.refresh()
                    this.mdchange()
                } else {
                    message.error(data.msg)
                    that.setState({
                        loading: false
                    })
                }
            })
    }

    mdchange() {
        let that = this
        let visible = !that.state.visible
        that.setState({
            visible
        })
        if (visible) {
            fetch('/Pay/view', {
                method: "POST",
                body: JSON.stringify({
                    id: this.props.id,
                })
            })
                .then(res => res.json())
                .then(data => {
                    that.setState({
                        condition: data.data ? data.data : {},
                        contract_id_react: data.contract_id_react ? data.contract_id_react : [],
                        company_id_react: data.company_id_react ? data.company_id_react : [],
                    })
                })
        } else {
            that.setState({
                condition: {},
                loading: false
            })
        }
    }

    onTimeChange(name, date, dateString) {
        let that = this
        console.log(name, date, dateString)
        let data = Object.assign({}, this.state.condition, {[name]: dateString})
        this.setState({
            condition: data
        })
    }

    onRangeChange(name, dates, dateStrings) {
        console.log(dates, dateStrings)
        let data = Object.assign({}, this.state.condition, {[name + '1']: dateStrings[0], [name + '2']: dateStrings[1]})
        this.setState({
            condition: data
        })
    }

    onSelChange(name, value, options) {
        let that = this
        console.log(name, value)
        let data = Object.assign({}, this.state.condition, {[name]: value})
        this.setState({
            condition: data
        })
        /*if (name == 'contract_id') {
            console.log(options)

            setTimeout(() => {
                    if (options) {
                        var condition = Object.assign({}, this.state.condition, {company_id: that.state.contract_id_react[options.key]['name2']})
                    } else {
                        var condition = Object.assign({}, this.state.condition, {company_id: null})
                    }
                    that.setState({
                        condition
                    })
                }
            )
        }*/
        if (name == 'company_id') {
            setTimeout(() => {
                that.onSelSearch3('contract_id', value)
            })
        }
    }

    onChange(name, e) {
        let that = this
        let value = e.target.value
        console.log(name, value)
        let data = Object.assign({}, this.state.condition, {[name]: value})
        this.setState({
            condition: data
        })
    }

    arrsel(arr) {
        if (arr) {
            return arr.map((item, index) =>
                <Option value={item.id} key={index}>{item.name}</Option>
            )
        }
    }


    onSelSearch = (name, value) => {
        let that = this
        fetch('/Ajax/searchContract', {
            method: "POST",
            body: JSON.stringify({
                name: value,
                test: that.props.type == 7 ? 1 : null
            })
        })
            .then(res => res.json())
            .then(data => {

                that.setState({
                    [name]: data
                })
            })

    }
    onSelSearch2 = (name, value) => {
        let that = this
        fetch('/Ajax/searchCompany', {
            method: "POST",
            body: JSON.stringify({
                name: value,
            })
        })
            .then(res => res.json())
            .then(data => {
                that.setState({
                    [name]: data
                })
            })

    }

    onSelSearch3 = (name, value) => {
        let that = this
        fetch('/Pay/getContractByCompany', {
            method: "POST",
            body: JSON.stringify({
                company_id: value,
                test: this.props.type == 7 || this.props.type == 8 ? 1 : 0
            })
        })
            .then(res => res.json())
            .then(data => {
                let condition = Object.assign({}, this.state.condition, {[name]: null})
                that.setState({
                    [name + '_react']: data.data ? data.data : [],
                    condition
                })
            })

    }


    render() {
        const columns = [
            {
                title: '选择',
                dataIndex: 'choose',
                key: 'choose',
                width: 70,
                align: 'center',
                render: (row, record) => {
                    return (<>
                        <Radio value={record.id}></Radio>
                    </>)
                },
            },
            {
                title: '合同编号',
                dataIndex: 'name',
                key: 'name',
                // width: 200,
                // fixed: 'left',
                // render: (row, record) => {
                //     return (<>
                //         <HtView id={record.id} title={row} refresh={()=>{}}/>
                //     </>)
                // },
            }, {
                title: '所属园区',
                dataIndex: 'yq_id',
                key: 'yq_id',
                // width: 150,
            }, {
                title: '生效时间',
                dataIndex: 'zltime',
                key: 'zltime',
                // width: 220,
            }, {
                title: '时长',
                dataIndex: 'duration',
                key: 'duration',
                width: 130,
            }
        ]
        if(this.props.type == 7){
            columns.push({
                title: '金额',
                dataIndex: 'amount',
                key: 'amount',
                width: 100,
            })
        }
        if(this.props.type != 7){
            columns.splice(3,0,{
                title: '房间',
                dataIndex: 'room',
                key: 'room',
                // width: 150,
            })
        }
        return (
            <>
                {this.props.id ?
                    <a href='javascript:void(0)' onClick={this.mdchange.bind(this)}>编辑</a>
                    :
                    <Button type="primary" onClick={this.mdchange.bind(this)}
                            icon={<PlusCircleOutlined/>}>录入</Button>
                }

                <Modal title="编辑" maskClosable={false} destroyOnClose={true} width={900}
                       visible={this.state.visible}
                       onCancel={this.mdchange.bind(this)} footer={null}>
                    <Form
                        layout="vertical"
                        // labelCol={{ span: 3 }}
                        wrapperCol={{span: 24}}
                        autoComplete="off"
                    >
                        <Row gutter={[20, 0]} justify="start">
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="公司"
                                    required={true}
                                >
                                    <Select
                                        // mode="multiple"
                                        allowClear
                                        style={{width: '100%'}}
                                        placeholder="请选择"
                                        value={this.state.condition.company_id ? this.state.condition.company_id : []}
                                        onChange={this.onSelChange.bind(this, 'company_id')}
                                        onSearch={this.onSelSearch2.bind(this, 'company_id_react')}
                                        maxTagCount="responsive"
                                        showSearch
                                        optionFilterProp="children"
                                    >
                                        {this.arrsel(this.state.company_id_react)}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={24}>
                                <Form.Item
                                    label="合同信息"
                                    required={true}
                                >
                                    {/*<Select
                                        // mode="multiple"
                                        allowClear
                                        style={{width: '100%'}}
                                        placeholder="请选择"
                                        value={this.state.condition.contract_id ? this.state.condition.contract_id : []}
                                        onChange={this.onSelChange.bind(this, 'contract_id')}
                                        onSearch={this.onSelSearch.bind(this, 'contract_id_react')}
                                        maxTagCount="responsive"
                                        showSearch
                                        optionFilterProp="children"
                                    >
                                        {this.arrsel(this.state.contract_id_react)}
                                    </Select>*/}
                                    <Radio.Group onChange={this.onChange.bind(this, 'contract_id')}
                                                 value={this.state.condition.contract_id ? this.state.condition.contract_id : null}
                                                 style={{width: '100%'}}
                                    >
                                        <Table
                                            bordered
                                            columns={columns}
                                            dataSource={this.state.contract_id_react ? this.state.contract_id_react : []}
                                            pagination={false}
                                            // loading={tableloading}
                                            // rowSelection={rowSelection}
                                            className='table'
                                            // scroll={{x: 2800}}
                                        />
                                    </Radio.Group>
                                </Form.Item>
                            </Col>
                            {/*<Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="公司"
                                    // required={true}
                                >
                                    <Input placeholder="请输入"
                                           disabled={true}
                                           value={this.state.condition.company_id ? this.state.condition.company_id : null}/>
                                </Form.Item>
                            </Col>*/}
                            {this.props.type == 3 || this.props.type == 4 || this.props.type == 7 || this.props.type == 8 ?
                                <>
                                    <Col className="gutter-row" span={12}>
                                        <Form.Item
                                            label='缴费时间'
                                            required={true}
                                        >
                                            <DatePicker className="input" placeholder="请选择"
                                                        onChange={this.onTimeChange.bind(this, 'time1')}
                                                        value={this.state.condition.time1 ? moment(this.state.condition.time1) : null}
                                                        style={{width: "100%"}}
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col className="gutter-row" span={12}>
                                        <Form.Item
                                            label="缴费金额"
                                            required={true}
                                        >
                                            <Input placeholder="请输入"
                                                   value={this.state.condition.num ? this.state.condition.num : null}
                                                   onChange={this.onChange.bind(this, 'num')} suffix={"元"}/>
                                        </Form.Item>
                                    </Col>
                                </>
                                :
                                <>
                                    <Col className="gutter-row" span={12}>
                                        <Form.Item
                                            label={this.props.timename ? this.props.timename : "缴费周期"}
                                            required={true}
                                        >
                                            <RangePicker style={{width: '100%'}}
                                                         disabled={this.props.id ? true : false}
                                                         allowEmpty={[true, true]}
                                                         onChange={this.onRangeChange.bind(this, 'time')}
                                                         value={[(this.state.condition.time1 ? moment(this.state.condition.time1) : null), (this.state.condition.time2 ? moment(this.state.condition.time2) : null)]}
                                                         placeholder={['请输入', '请输入']}/>
                                        </Form.Item>
                                    </Col>
                                    <Col className="gutter-row" span={12}>
                                        <Form.Item
                                            label="应缴金额"
                                            required={true}
                                        >
                                            <Input placeholder="请输入"
                                                   value={this.state.condition.num ? this.state.condition.num : null}
                                                   onChange={this.onChange.bind(this, 'num')} suffix={"元"}/>
                                        </Form.Item>
                                    </Col>
                                </>
                            }
                            <Col className="gutter-row" span={24}>
                                <Form.Item>
                                    <Row justify={"center"}>
                                        <Button type='primary' onClick={this.sub.bind(this)}
                                                loading={this.state.loading}>提交</Button>
                                    </Row>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </Modal>
            </>
        )
    }
}

export default Edit
